import Common from '../wp-controlers/common-panel/geralAttributes';

export default {
  image: {
    type: 'object',
    default: {
      id: '',
      src: '',
      alt: '',
    },
  },
  removeImage: {
    type: 'boolean',
    default: false,
  },
  sizeImage: {
    type: 'string',
    default: 'normal',
  },
  titleCard: {
    type: 'string',
    default: '',
  },
  numberCard: {
    type: 'string',
    default: '1',
  },
  variant: {
    type: 'string',
    default: 'default',
  },
  hAlign: {
    type: 'string',
    default: 'hAlign-center',
  },
  textAfter: {
    type: 'boolean',
    default: false,
  },
  variantColored: {
    type: 'string',
    default: 'cardBlue',
  },
  background: {
    type: 'string',
    default: 'bg-blue',
  },
  originalSize: {
    type: 'boolean',
    default: false,
  },
  marginImage: {
    type: 'string',
    default: 'margin-base',
  },
  anchor: {
    type: 'string',
    default: '',
  },
  hasNumber: {
    type: 'boolean',
    default: false,
  },
  ...Common,
};
